import { PlaybookLine } from './PlaybookLine';

export class Character {
  playFun: (line: PlaybookLine, text: string) => Promise<void>;
  constructor(
    public id: number,
    public name: string, //public displayName?: string,
  ) {}
  getDisplayName() {
    return /*this.displayName || */ this.name;
  }
  async play(line: PlaybookLine, text: string) {
    if (this.playFun) {
      return this.playFun(line, text);
    } else {
      return;
    }
  }
}
